/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-multi-comp */
import 'react-datepicker/dist/react-datepicker.css';
import React, { useState, useReducer, useEffect } from 'react';
import _, { isFunction } from 'lodash';
import { Alert, Form, Button, DatePicker, FormControl } from 'rsuite';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { ButtonIcon, ColumnStatus, WidgetAccount, WidgetDate, WidgetTitleSubtitle } from '../components/index.js';
import { signsService, cuotitasStoreService } from '../services/index.js';
import { Table } from '../components/table/Table.js';
import FilterQueryParams from '../components/FilterQueryParams.js';
import { dateFns } from '../components/DateFnsUtils.js';
import REQUEST_TYPES from '../constants/signs/requestTypes.js';
import singsStatuses from '../components/statuses.js';
import Tabs from '../components/Tabs.js';
import validator from '../helpers/validator.js';
import DialogUserUpdate from '../components/dialog/DialogUserUpdate.js';

function ColumnName (cellContent) {
    return (
        <WidgetTitleSubtitle
            title={(<WidgetAccount account={[cellContent.name, cellContent.lastname]} />)}
        />
    );
}

function ColumnDate (cellContent) {
    return (<WidgetDate date={new Date(cellContent)} />);
}

function ColumnState (cellContent, row) {
    return (<ColumnStatus type={cellContent.type} text={cellContent.text} />);
}

function ColumnActions (cellContent, row, rowIndex, { dialogUserUpdateOpen }) {
    return (
        <div>
            <ButtonIcon
                title='Ver Contrato'
                size='small'
                icon={(<VisibilityIcon className='svg-icon' />)}
                onClick={() => dialogUserUpdateOpen(row.id)}
            />
        </div>
    );
}

export default function LoansRequests () {
    const tabs = [
        { id: 1, name: 'pending', label: 'Pendientes' },
        { id: 2, name: 'success', label: 'Exitosos' },
        { id: 3, name: 'fails', label: 'Rechazados' },
        { id: 4, name: 'deleted', label: 'Anulados' },
    ];

    const columns = [
        { dataField: 'id', text: 'ID', sort: false },
        { dataField: 'name', text: 'Cliente', sort: false, align: 'left', formatter: ColumnName },
        { dataField: 'dni', text: 'DNI', sort: false, align: 'left', headerAlign: 'left' },
        { dataField: 'commerceName', text: 'Comercio', sort: false, align: 'left', headerAlign: 'left' },
        { dataField: 'idLoan', text: 'Nro. de Crédito', sort: false },
        { dataField: 'created_at', sort: false, text: 'Fecha', formatter: ColumnDate },
        { dataField: 'status', text: 'Estado', sort: false, align: 'left', headerAlign: 'left', formatter: ColumnState },
        { dataField: 'idPerson', text: ' ', sort: false, align: 'center', formatExtraData: { dialogUserUpdateOpen }, formatter: ColumnActions }
    ];

    const [isLoading, setIsLoading] = useState(false);

    const [query, setQuery] = useReducer((oldQuery, newQuery) => {
        if (isFunction(newQuery)) {
            return newQuery(oldQuery);
        }
        return newQuery;
    }, {
        sortOrder: 'desc',
        sortField: 'ID',
        pageNumber: 1,
        pageSize: 10
    });

    const [tab, setTab] = useState(tabs[0]);

    const [search, setSearch] = useState('');
    const [date, setDate] = useState(null);

    const [signList, setSignList] = useState([]);
    const [signSelected, setSignSelected] = useState();

    const [dialogUserUpdateIsOpen, setDialogUserUpdateIsOpen] = useState(false);

    function dialogUserUpdateOpen (id) {
        setSignSelected(id);
        setDialogUserUpdateIsOpen(true);
    }

    function dialogUserUpdateClose () {
        setSignSelected(0);
        setDialogUserUpdateIsOpen(false);
        filter();
    }

    async function filter () {
        try {
            setIsLoading(true);

            const sortOrder = query.sortOrder;
            const sortField = query.sortField;

            const filters = new FilterQueryParams();

            filters.equal('id_cuotitas_request_type', REQUEST_TYPES.commerceSignsRequests);
            filters.equal('id_cuotitas_request_status', tab.id);

            if (date) {
                const startAt = dateFns.parse(dateFns.format(date, 'y-MM-dd 00:00:00'), 'y-MM-dd HH:mm:ss');
                const startTo = dateFns.parse(dateFns.format(date - 1, 'y-MM-dd 00:00:00'), 'y-MM-dd HH:mm:ss');

                filters.between(
                    'created_at',
                    dateFns.format(startTo, 'y-MM-dd 00:00:00'),
                    dateFns.format(startAt, 'y-MM-dd 23:59:59')
                );
            }

            if (search.length > 2 && validator.isInteger(search)) {
                filters.like('person.documents.document', `*${search}*`);
            }

            if (search.length > 2 && !validator.isInteger(search)) {
                filters.like('person.attributes.description', `*${search}*`);
            }

            const signs = await signsService.getRequests({
                filters: filters.build(),
                order: `${sortField}-${sortOrder.toUpperCase()}`,
                pageSize: query.pageSize,
                page: query.pageNumber,
            });

            let loans = [];

            if (signs.length > 0) {
                loans = await cuotitasStoreService.getLoans({
                    with: 'loan_request',
                    filters: `id_sign_request in ${signs.map(req => req.id).join(';')}`,
                    pageSize: 0
                });
            }

            const recharges = signs.map(sign => {
                const result = {};

                const personAttributes = _.reduce(sign.person?.attributes, (result, value, key) => {
                    result[value.description] = value.value;
                    return result;
                }, {});

                const loan = loans.find(req => req.id_sign_request === sign.id) || {};

                result.id = sign.id;
                result.name = {};
                result.name.name = personAttributes.first_name || sign.person?.attributes?.[0]?.value || 'S/D';
                result.name.lastname = personAttributes.last_name || sign.person?.attributes?.[1]?.value || 'S/D';
                result.dni = sign.person?.documents?.[0]?.description || 'S/D';
                result.commerceName = sign.store?.name || 'S/D';
                result.idLoan = loan.loan_request?.metadata?.response?.NumeroCredito || 'S/D';
                result.created_at = sign.created_at;
                result.status = singsStatuses[sign.id_cuotitas_request_status];
                result.idPerson = sign?.person?.id;

                return result;
            });

            setSignList(recharges);
        }
        catch {
            Alert.error('Se produjo un error interno, te pedimos disculpas. Por favor, intentalo de nuevo más tarde.', 5000);
        }
        finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        filter();
    }, [query, tab, date]);

    useEffect(() => {
        if (search === '') {
            filter();
        }
    }, [search]);

    useEffect(() => {
        setQuery({ ...query, pageNumber: 1 });
    }, [tab]);

    return (
        <main className='page'>
            <h1 className="page-header">
                Firmas Cuota Ya
            </h1>
            <div className="page-filters">
                <Tabs
                    className="page-filters-tabs"
                    items={tabs}
                    selected={tab}
                    onSelect={setTab}
                />
                <div className="page-filters-toolbar">
                    <Form id="form-toolbar" className="page-filters-form" onSubmit={filter}>
                        <FormControl
                            placeholder="Buscar por nombre o DNI"
                            appearance='subtle'
                            style={{ width: 300 }}
                            value={search}
                            onChange={setSearch}
                        />
                        <DatePicker
                            oneTap
                            style={{ width: 150 }}
                            size='md'
                            placeholder='Fecha de Alta'
                            limitEndYear={2020}
                            renderValue={(value, format) => `${dateFns.format(value, 'dd/MM/y')}`}
                            onChange={setDate}
                            onClean={() => setDate(null)}
                        />
                    </Form>
                    <div className="page-filters-actions">
                        <Button type="submit" form="form-toolbar" appearance='primary' loading={isLoading}>
                            Buscar
                        </Button>
                    </div>
                </div>
            </div>
            <div className='page-content'>
                <Table
                    data={signList}
                    columns={columns}
                    onChange={setQuery}
                    isLoading={isLoading}
                    pagination={{
                        sizePerPage: query.pageSize,
                        page: query.pageNumber,
                    }}
                />
            </div>
            {dialogUserUpdateIsOpen && <DialogUserUpdate
                show={dialogUserUpdateIsOpen}
                onHide={dialogUserUpdateClose}
                id= {signSelected}
            />}
        </main>
    );
}
